const INITIAL_STATE = {
  email: '',
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  default:
    return { ...state };
  }
};

export default reducer;
